import {Outlet} from "react-router-dom";

export default function Template() {
    return (
        <div className={"container-xxl py-4"}>
            <div className={"px-4 py-4 min-h-100 bg-white shadow-sm rounded-1"}>
                <Outlet />
            </div>
        </div>
    )
}